const BriefcaseIcon = ({ color = "#6B7280", width = 20, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 2V0.5C6 0.22 6.22 0 6.5 0H13.5C13.78 0 14 0.22 14 0.5V2H17C18.1046 2 19 2.89543 19 4V13C19 14.1046 18.1046 15 17 15H3C1.89543 15 1 14.1046 1 13V4C1 2.89543 1.89543 2 3 2H6ZM7 1V2H13V1H7ZM10.75 8.25H9.25V9.75H10.75V8.25ZM2.5 5V7.5H8.5V6.5C8.5 6.22 8.72 6 9 6H11C11.28 6 11.5 6.22 11.5 6.5V7.5H17.5V5C17.5 4.72 17.28 4.5 17 4.5H3C2.72 4.5 2.5 4.72 2.5 5ZM17.5 9.5H11.5V10.5C11.5 10.78 11.28 11 11 11H9C8.72 11 8.5 10.78 8.5 10.5V9.5H2.5V13C2.5 13.28 2.72 13.5 3 13.5H17C17.28 13.5 17.5 13.28 17.5 13V9.5Z"
      fill={color}
    />
  </svg>
);

export default BriefcaseIcon;
